/**
 * Apple Ads 域：盯盘策略运行记录 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 apple_asa.dtos.watch_strategy_result 对齐。
 *   - GET  /api/v1/apple-asa/auto-ad-operate-result         → 分页过滤查询（含媒体交互状态/响应报文预留列）
 *   - GET  /api/v1/apple-asa/auto-ad-operate-result/enums   → 操作类型下拉枚举
 *
 * 数据源 t_apple_watch_strategy_result（run_apple_watch_strategy 盯盘策略命中 +
 * 红线命中落库；本轮引擎只判断 + 存储、不调 Apple API 执行，status / message 恒空串）。
 */

import { request } from "../apiClient";

/** 盯盘策略运行记录单行（与后端 WatchStrategyResultRecord 对齐，11 字段；id 仅供 React key 不展示）。 */
export interface AutoAdOperateResultRecord {
  id: string;
  keyword_id: string;
  keyword: string;
  adgroup_id: string;
  adgroup_name: string;
  campaign_id: string;
  action_name: string;
  condition: string;
  status: string;
  message: string;
  created_time: string;
}

/**
 * 盯盘策略运行记录查询入参（与后端 WatchStrategyResultQuery 对齐，字段均可选）。
 * 用 `type` 而非 `interface`：TS 中对象 type 别名可隐式满足 apiClient 的
 * `Record<string, ...>` 索引签名（interface 不行）。
 */
export type AutoAdOperateResultQuery = {
  ds_start?: string;
  ds_end?: string;
  keyword_id?: string;
  keyword?: string;
  adgroup_id?: string;
  campaign_id?: string;
  action_name?: string;
  condition?: string;
  page?: number;
  page_size?: number;
};

/** 盯盘策略运行记录分页结果（与后端 WatchStrategyResultPage 对齐）。 */
export interface AutoAdOperateResultPage {
  items: AutoAdOperateResultRecord[];
  total: number;
  page: number;
  page_size: number;
}

/** 盯盘策略运行记录下拉枚举（与后端 WatchStrategyResultEnums 对齐）。 */
export interface AutoAdOperateResultEnums {
  action_name: string[];
}

/** 分页过滤查询盯盘策略运行记录。 */
export async function getAutoAdOperateResult(
  query: AutoAdOperateResultQuery,
): Promise<AutoAdOperateResultPage> {
  const data = await request<AutoAdOperateResultPage | null>(
    "/api/v1/apple-asa/auto-ad-operate-result",
    { query },
  );
  return (
    data ?? {
      items: [],
      total: 0,
      page: query.page ?? 1,
      page_size: query.page_size ?? 20,
    }
  );
}

/** 取操作类型下拉枚举（DISTINCT 自表）。 */
export async function getAutoAdOperateResultEnums(): Promise<AutoAdOperateResultEnums> {
  const data = await request<AutoAdOperateResultEnums | null>(
    "/api/v1/apple-asa/auto-ad-operate-result/enums",
  );
  return data ?? { action_name: [] };
}
